import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-noCheck",
  "use": "icon-noCheck-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-noCheck\">\r\n<rect x=\"1.5\" y=\"1.5\" width=\"13\" height=\"13\" rx=\"0.5\" stroke=\"#D1D1D1\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol